import { useState } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectIsAuthenticated } from '@/features/auth/authSelectors'
import { ROUTES } from '@/constants/routes'
import Sidebar from './Sidebar'
import Header from './Header'

// Map route → page title/subtitle keys
const PAGE_META = {
  [ROUTES.DASHBOARD]:     { title: 'dashboard.title',     subtitle: 'dashboard.subtitle' },
  [ROUTES.USERS]:         { title: 'users.title',         subtitle: 'users.subtitle' },
  [ROUTES.USER_DETAIL]:   { title: 'تفاصيل المستخدم',     subtitle: null },
  [ROUTES.VENDORS]:       { title: 'vendors.title',       subtitle: 'vendors.subtitle' },
  [ROUTES.VENDOR_DETAIL]: { title: 'تفاصيل البائع',       subtitle: null },
  [ROUTES.CATEGORIES]:    { title: 'nav.categories',      subtitle: null },
  [ROUTES.PRODUCTS]:      { title: 'nav.products',        subtitle: null },
  [ROUTES.PRODUCTS_IMPORT]: { title: 'productsImport.title', subtitle: null },
  [ROUTES.ORDERS]:        { title: 'orders.title',        subtitle: 'orders.subtitle' },
  [ROUTES.SHIPPING]:      { title: 'nav.shipping',        subtitle: null },
  [ROUTES.PROMOTIONS]:    { title: 'nav.promotions',      subtitle: null },
  [ROUTES.REVIEWS]:       { title: 'reviews.title',       subtitle: 'reviews.subtitle' },
  [ROUTES.NOTIFICATIONS]: { title: 'nav.notifications',   subtitle: null },
  [ROUTES.BANNERS]:       { title: 'nav.banners',         subtitle: null },
}

export default function AdminLayout() {
  const { t } = useTranslation()
  const isAuth = useSelector(selectIsAuthenticated)
  const [collapsed, setCollapsed] = useState(false)
  const location = useLocation()

  if (!isAuth) {
    return <Navigate to={ROUTES.LOGIN} replace />
  }

  // Find meta for current route — prefer longest (most specific) match
  const routeKey = Object.keys(PAGE_META)
    .filter((k) => {
      const pattern = k.replace(/:\w+/g, '[^/]+')
      return new RegExp(`^${pattern}(/|$)`).test(location.pathname)
    })
    .sort((a, b) => b.length - a.length)[0]
  const meta = PAGE_META[routeKey] || { title: 'app.admin', subtitle: null }

  return (
    <div className="flex h-screen overflow-hidden" style={{ background: '#F9F9F9' }}>
      {/* Sidebar */}
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} />

      {/* Main area */}
      <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
        <Header
          pageTitle={t(meta.title)}
          pageSubtitle={meta.subtitle ? t(meta.subtitle) : null}
        />

        {/* Page content */}
        <main className="flex-1 overflow-y-auto p-6">
          <div className="animate-in">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  )
}
